import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Integration {
  id: string;
  name: string;
  provider: string;
  status: string;
  webhook_url?: string;
}

export default function Integrations() {
  const [integrations, setIntegrations] = useState<Integration[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadIntegrations();
  }, []);

  async function loadIntegrations() {
    try {
      setLoading(true);
      setError('');
      const res = await api.get('/api/integrations');
      setIntegrations(res.data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function copyWebhook(url: string) {
    navigator.clipboard.writeText(url).catch(() => {});
  }

  return (
    <div>
      <h1 style={styles.heading}>Integrations</h1>
      {error && <div style={styles.error}>{error}</div>}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={styles.card}>
          {integrations.length === 0 && <div style={styles.empty}>No integrations configured</div>}
          {integrations.map((i) => (
            <div key={i.id} style={styles.row}>
              <div>
                <div style={styles.rowTitle}>{i.name}</div>
                <div style={styles.rowMeta}>
                  {i.provider} • {i.status}
                </div>
                {i.webhook_url && (
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 4 }}>
                    <code style={{ fontSize: 12, background: '#f3f4f6', padding: '2px 6px', borderRadius: 4 }}>{i.webhook_url}</code>
                    <button
                      onClick={() => copyWebhook(i.webhook_url!)}
                      style={{ ...styles.buttonSmall, background: '#e5e7eb', color: '#111827' }}
                    >
                      Copy
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  card: { background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb' },
  empty: { padding: 20, color: '#9ca3af' },
  row: { padding: '12px 16px', borderBottom: '1px solid #f3f4f6' },
  rowTitle: { fontWeight: 500, fontSize: 14 },
  rowMeta: { fontSize: 12, color: '#6b7280', marginTop: 2 },
  buttonSmall: { padding: '4px 10px', fontSize: 12, border: 'none', borderRadius: 6, cursor: 'pointer' },
};
